import { makeStyles } from 'lib/components'; // #genai

export default makeStyles((theme) => ({
  subscriptionCard: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: '16px',
    borderRadius: '16px',
    border: `1px solid ${theme.evPalette.charcoal[400]}`,
    flex: '1 1 100%',
    height: '140px',
    '@media (min-width: 1024px)': {
      flex: '0 0 calc(50% - 8px)',
    },
    justifyContent: 'space-between',
  },
  subscriptionCardContent: {
    display: 'flex',
    gap: '8px',
    padding: '0 8px 8px 8px',
    '@media (min-width: 640px)': {
      padding: '0 16px 8px 16px',
      gap: '16px',
    },
  },
  subscriptionDetails: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    flex: 1,
  },
  subscriptionInfo: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '8px',
  },
  subscriptionHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '12px',
  },
  subscriptionIconContainer: {
    width: '60px',
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
  },
  iconStyle: {
    width: '60px',
    height: '60px',
  },
  subscriptionIcon: {
    width: '38px',
    height: '20px',
    position: 'absolute',
    left: '27px',
    top: '7px',
    backgroundColor: theme.evPalette.salt[100],
    border: `1px solid ${theme.evPalette.ocean[600]}`,
    borderRadius: '20px',
    padding: '6px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  subscriptionIconText: {
    color: theme.evPalette.ocean[600],
    fontFamily: 'Noto Sans',
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '16px',
    letterSpacing: '0.33px',
  },
  subscriptionName: {
    flex: 1,
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '20px',
    whiteSpace: 'nowrap',
  },
  priceContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'baseline',
  },
  priceText: {
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: 'normal',
    color: theme.evPalette.charcoal[600],
  },
  datesAndOrderHistoryContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '8px',
    '@media (min-width: 1200px)': {
      gap: '16px',
    },
  },
  datesContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  dateRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    alignItems: 'baseline',
  },
  dateLabel: {
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '18px',
    color: theme.evPalette.charcoal[700],
    width: '55px',
  },
  dateValue: {
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: 'normal',
    color: theme.evPalette.charcoal[800],
  },
  consumptionContainer: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.evPalette.charcoal[100],
    borderRadius: '0px 0px 16px 16px',
    overflow: 'hidden',
  },
  consumptionRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '8px',
    height: '40px',
    padding: '4px 16px 4px 16px',
  },
  consumptionInfo: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '24px',
  },
  consumptionInfoDetails: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  consumptionProgress: {
    borderRadius: '0px 0px 16px 16px',
  },
  consumptionProgressBar: {
    backgroundColor: 'transparent',
  },
  overageProgressBar: {
    backgroundColor: theme.evPalette.mango[700],
  },
  underageProgressBar: {
    backgroundColor: '#3E649B',
  },
  overageBadge: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: theme.evPalette.mango[700],
    color: theme.evPalette.salt[100],
    borderRadius: '8px',
    padding: '0px 8px',
    height: '20px',
  },
  viewOrdersLink: {
    textTransform: 'none',
    textDecoration: 'underline',
    color: theme.evPalette.ocean[600],
  },
  summaryPaper: {
    padding: '24px',
    borderRadius: '4px',
    width: '100%',
    '@media (min-width: 1200px)': {
      width: '300px',
      minWidth: '300px',
    },
  },
  summaryTitle: {
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '24px',
    marginBottom: '16px',
  },
  summaryContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  summaryRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '16px',
  },
  summaryDivider: {
    height: '1px',
    backgroundColor: theme.evPalette.charcoal[400],
    margin: '8px 0',
  },
  totalLabel: {
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '20px',
  },
  actionButtonsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    '@media (min-width: 640px)': {
      flexDirection: 'row',
    },
  },
  actionButton: {
    textTransform: 'none',
    flex: 1,
    '@media (min-width: 640px)': {
      flex: '0 1 auto',
      minWidth: '180px',
    },
  },
}));
